import {Accordion, Carousel, Center, Folio, Stepper} from './components';

export default {
    Accordion,
    Carousel,
    Center,
    Folio,
    Stepper
};
